<template>
  <div
    class="dialog"
    :class="{ 'dialog--single': isSingleContent }"
    v-show="value"
  >
    <div class="dialog__container">
      <div class="dialog__title">Recommended Products</div>
      <div class="dialog__body">
        <div class="recommended">
          <div
            v-for="(item, index) in recommendedItems"
            :key="`recommended-item-${index + 1}`"
            class="recommended__item"
          >
            <RecommendedItem :item="item"></RecommendedItem>
          </div>
        </div>
        <button type="button" class="dialog__close" @click="handleClickClose">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import RecommendedItem from './RecommendedItem.vue'
export default {
  components: {
    RecommendedItem,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    recommendedItems: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      imageLoaded: false,
      slickInitialized: false,
    }
  },
  computed: {
    isSingleContent() {
      return this.recommendedItems.length === 1
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.initSlick()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    this.destroySlick()
  },
  methods: {
    handleClickClose() {
      this.$emit('close')
    },
    handleImageLoad() {
      setTimeout(() => {
        this.imageLoaded = true
      }, 1)
    },
    /* eslint-disable no-undef */
    initSlick() {
      if (window.innerWidth <= 1080 && !this.slickInitialized) {
        const $carousel = $(this.$refs.carousel)
        $carousel.slick({
          dots: false,
          infinite: false,
          speed: 300,
          variableWidth: true,
          arrows: false,
          touchThreshold: 100,
          swipe: true,
          slidesToScroll: 4,
        })
        this.slickInitialized = true
      }
    },
    /* eslint-disable no-undef */
    destroySlick() {
      if (this.slickInitialized) {
        $(this.$refs.carousel).slick('unslick')
        this.slickInitialized = false
      }
    },
    handleResize() {
      if (window.innerWidth <= 1080) {
        this.initSlick()
      } else {
        this.destroySlick()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';

// Dialog
$dialog: '.dialog';
#{$dialog} {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  box-sizing: border-box;
  &__container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 506px;
    background-color: #fff;
    border-radius: 30px;
    padding: 40px 40px 50px;
    box-sizing: border-box;
  }
  &__title {
    font-family: 'LG EI Headline';
    font-size: 22px;
    line-height: 22px;
    font-weight: 400;
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 20px;
  }
  &__close {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 29px;
    right: 34px;
    background: url('/theme/rbFront/img/w/magnit/button-close.png') no-repeat
      center center;
    border: none;
    font-size: 16px;
    color: #000;
    text-indent: -9999px;
    overflow: hidden;
  }
  &--single {
    #{$dialog}__container {
      width: 386px;
    }
  }
  @media screen and (max-width: 1080px) {
    &__container {
      width: calc(100% - 24px) !important;
      border-radius: 15px;
      padding: 20px 27px 20px !important;
    }
    &__body {
      gap: 12px;
      margin-top: 5px;
    }
    &__title {
      font-size: 16px;
      line-height: 22px;
      padding: 0 4px;
      text-align: left !important;
    }
    &__close {
      top: 21px;
      right: 16px;
      width: 14px;
      height: 14px;
      background-size: contain;
    }
  }
}

.recommended {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 58px 0;
  &__item {
    display: flex;
    width: 48%;
    flex-grow: 0;
    flex-shrink: 0;
  }
  @media screen and (max-width: 1080px) {
    gap: 16px 0px;
  }
}
</style>
